import React from 'react';
import { useAppSelector } from '../../../app/hooks';
import { BankApp } from '@fncrdbl/bank-sdk/dist/esm';
import { selectBankSdkCustomizations } from '../../../app/slices/customizations.slice';
import { useBankAppConfiguration } from '../../../hooks/useBankAppConfiguration';
import useForwardingSubtitleCustomization from '../../../hooks/useForwardingSubtitleCustomization';
import { useBankListKeyboardAccessibility } from '../../../hooks/useBankListKeyboardAccessibility';
import { useAppTranslation } from '../../../i18n';

export const BankInterface = () => {
	const configuration = useBankAppConfiguration();
	const { t } = useAppTranslation();
	const containerRef = useBankListKeyboardAccessibility<HTMLDivElement>({
		countrySelectLabel: t('a11y.change-country')
	});

	let bankSdkCustomizations = useAppSelector(selectBankSdkCustomizations) as any;
	bankSdkCustomizations = useForwardingSubtitleCustomization(bankSdkCustomizations);

	return (
		<div id="bank-step" className="bank-interface-step" ref={containerRef}>
			<BankApp configuration={configuration} customizations={bankSdkCustomizations} />
		</div>
	);
};

export default BankInterface;
